import type { ApiSchemas } from '@rental/contracts/client'

type Hold = NonNullable<ApiSchemas['StaffBookingRow']['hold']>

/**
 * W2-S S4: where a website draft's hold stands, in words for the counter. The
 * server decides what the hold means for capacity; this only says it. A hold
 * let go, or past its time and not yet let go by the minute's job, is over.
 */
export type HoldState = { kind: 'held'; until: string } | { kind: 'ended' }

export function holdState(hold: Hold | null, now: Date): HoldState | null {
  if (!hold) return null
  if (hold.releasedAt !== null || Date.parse(hold.expiresAt) <= now.getTime()) {
    return { kind: 'ended' }
  }
  return { kind: 'held', until: hold.expiresAt }
}
